import { type Theme, Flex, Text, useTheme, Skeleton } from '@shared/components';

export interface SummaryStatsCardProps {
  title: string;
  displayValue: string;
  loading?: boolean;
  color?: 'primary' | 'default';
}

const getCardColors = (theme: Theme, color: 'primary' | 'default' = 'default') => {
  const colorMapping = {
    primary: {
      backgroundColor: theme.palette.primary.lighter,
      skeletonColor: theme.palette.primary.light,
      titleAndInfoColor: theme.palette.text.primary,
      displayColor: theme.palette.text.primary,
    },
    default: {
      backgroundColor: theme.palette.grey[100],
      skeletonColor: theme.palette.grey[200],
      titleAndInfoColor: theme.palette.text.primary,
      displayColor: theme.palette.text.primary,
    },
  };

  return colorMapping[color] ?? colorMapping.default;
};

export default function SummaryStatsCard(props: Readonly<SummaryStatsCardProps>) {
  const { title, displayValue, color, loading: isLoading } = props;
  const theme = useTheme();

  const { backgroundColor, titleAndInfoColor, displayColor, skeletonColor } = getCardColors(
    theme,
    color,
  );

  return (
    <Flex
      sx={(theme) => ({
        backgroundColor,
        p: theme.spacing(4),
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(4),
        flex: 1,
      })}
    >
      <Flex sx={{ flexDirection: 'column', flex: 1 }}>
        <Text sx={{ color: titleAndInfoColor, width: '100%' }}>{title}</Text>
        <Flex sx={(theme) => ({ alignItems: 'baseline', gap: theme.spacing(1) })}>
          <Text
            variant='h3'
            sx={{
              color: displayColor,
              width: '100%',
            }}
          >
            {isLoading ? <Skeleton sx={{ backgroundColor: skeletonColor }} /> : displayValue}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
